export default __webpack_public_path__ + "static/depositNFT_light-18354bff12a4bf8cae7b3635ed4c46e2.png";